import { FC, memo } from 'react';
import { Select } from 'antd';
import Link from 'next/link';
import Icon from '@ant-design/icons';
import styles from './BrochureLink.module.scss';
import { BrochureLinkProps } from './BrochureLink.types';
import ArrowRight from '@/public/assets/arrow-right.svg';

const { Option } = Select;

const BrochureLink = memo((props: BrochureLinkProps) => {
  const { title, url } = props;
  return (
    <div className={styles.brochure_link_container}>
      <a
        target="_blank"
        href={url}
        rel="noopener noreferrer"
        className={styles.brochure_link_content}
      >
        <Icon
          component={ArrowRight}
          style={{ fontSize: 16 }}
          className={styles.link_button_title}
        />
        <span>{title}</span>
      </a>
      <div className={styles.brochure_link_remark}>
        按下「立即投保」即表示您確認已閱讀及明白有關產品小冊子及風險披露。
      </div>
    </div>
  );
});
export default BrochureLink;
